/**
 * author : Ananthapadmanabhan V K
 */

import React, { useState, useEffect, useRef } from 'react';
import { withTranslation, useTranslation } from "react-i18next";

const SearchBox = ({ t, data, onFilteredData }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredItems, setFilteredItems] = useState(data);

  const prevSearchTermRef = useRef(searchTerm);

  useEffect(() => {
    const prevSearchTerm = prevSearchTermRef.current;
    if (searchTerm.trim() === '') {
      // If search term is empty, reset to the original data
      setFilteredItems(data);
      onFilteredData(data);
    } else if (searchTerm !== prevSearchTerm) {
      // If search term has changed, filter the data
      const filtered = searchItems(data, searchTerm);
      setFilteredItems(filtered);
      onFilteredData(filtered);
    }

    // Update the previous search term ref
    prevSearchTermRef.current = searchTerm;
  }, [searchTerm, data, onFilteredData]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const searchItems = (items, term) => {
    const lowerTerm = term.toLowerCase();
    const result = [];

    const searchObject = (obj) => {
      let found = false;

      // Check if the search term matches "name" property of topic
      if (obj.name && obj.name.toLowerCase().includes(lowerTerm)) {
        found = true;
      }

      // Check within localizedContents only if not found in topic
      if (!found && obj.localizedContents) {
        const filteredContents = obj.localizedContents.filter(
          (content) =>
            content.fieldName === 'name' &&
            content.translatedValue.toLowerCase().includes(lowerTerm)
        );

        if (filteredContents.length > 0) {
          obj = { ...obj, localizedContents: filteredContents };
          found = true;
        }
      }

      // Check within children only if not found in topic or localizedContents
      if (!found && obj.children) {
        const filteredChildren = obj.children
          .map((child) => searchObject(child))
          .filter((child) => child !== null);

        if (filteredChildren.length > 0) {
          obj = { ...obj, children: filteredChildren };
          found = true;
        }
      }

      return found ? obj : null;
    };

    items.forEach((item) => {
      const resultItem = searchObject(item);
      if (resultItem) {
        result.push(resultItem);
      }
    });

    return result;
  };


  return (
    <div>
      <input
        className='form-control '
        type="search"
        placeholder={t("Search.label")}
        value={searchTerm}
        onChange={handleSearchChange}
      />
    </div>
  );
};

export default withTranslation()(SearchBox);
